import React, {
  ReactNode,
  RefObject,
  createContext,
  useRef,
  useState,
} from 'react';
import { Socket } from 'socket.io-client';

export const events = {
  JOIN_ROOM: 'JOIN_ROOM',
  ADD_MESSAGE: 'ADD_MESSAGE',
  JOIN_STREAM: 'JOIN_STREAM',
  UPDATE_ROOM: 'UPDATE_ROOM',
  LEAVE_ROOM: 'LEAVE_ROOM',
  NOTIFY: 'NOTIFY',
  OPEN_PM: 'OPEN_PM',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  SET_DELETION: 'SET_DELETION',
  SET_VOICE: 'SET_VOICE',
  SET_MOD: 'SET_MOD',
  SET_BLOCKED: 'SET_BLOCKED',
  SET_BLOCKLIST: 'SET_BLOCKLIST',
  SET_ECHO: 'SET_ECHO',
  START_RAFFLE: 'START_RAFFLE',
  JOIN_RAFFLE: 'JOIN_RAFFLE',
  CANCEL_RAFFLE: 'CANCEL_RAFFLE',
  KICK_RAFFLE: 'KICK_RAFFLE',
  TRIGGER_RAFFLE: 'TRIGGER_RAFFLE',
  START_POLL: 'START_POLL',
  VOTE_POLL: 'VOTE_POLL',
  END_POLL: 'END_POLL',
  CLEAR_POLL: 'CLEAR_POLL',
};

interface ChatContextType {
  client: Socket | null;
  setClient: (client: Socket) => void;
  overviewUser: any | null;
  setOverviewUser: (user: any) => void;
  activeOverview: RefObject<HTMLElement | null> | null;
}

const initialChatContext = {
  client: null,
  setClient: (client: Socket) => {},
  overviewUser: null,
  setOverviewUser: (user: any) => {},
  activeOverview: null,
};

export const ChatContext = createContext<ChatContextType>(initialChatContext);

export const roleLevels = {
  admin: 100,
  streamer: 75,
  mod: 70,
  user: 50,
  visitor: 45,
  banned: 0,
};

export const useChat = () => {
  const { client, setClient, overviewUser, setOverviewUser, activeOverview } =
    React.useContext(ChatContext);

  return {
    client,
    setClient,
    overviewUser,
    setOverviewUser,
    activeOverview,
    hideOverview: () => {
      setOverviewUser(null);
      if (activeOverview) activeOverview.current = null;
    },
    handleShowOverview: (e, user, elementRef) => {
      e.preventDefault();
      e.stopPropagation();
      setOverviewUser(user);
      if (activeOverview) activeOverview.current = elementRef.current;
    },
  };
};

export const ChatProvider = ({ children }: { children: ReactNode }) => {
  const [client, setClient] = useState<Socket | null>(null);
  const [overviewUser, setOverviewUser] = useState<any | null>(null);
  const activeOverview = useRef(null);

  return (
    <ChatContext
      value={{
        client,
        setClient,
        overviewUser,
        setOverviewUser,
        activeOverview,
      }}
    >
      {children}
    </ChatContext>
  );
};
